import React, { FC, useMemo } from 'react';
import { Container, Grid, Link, Typography } from '@material-ui/core';
import PhotoCard from './components/PhotoCard';
import InformationCard from './components/InformationCard';
import Employee from 'src/interfaces/api/Employee';
import { useRecoilValue } from 'recoil';
import employeesState from 'src/recoil/atoms/employees';
import Breadcrumbs from 'src/components/Breadcrumbs';

interface Props {
  openToast: (success: boolean, message: string) => void;
  user?: any;
}

const Settings: FC<Props> = ({ user, openToast }) => {
  const employees = useRecoilValue(employeesState);

  const me = useMemo(() => {
    const me = Object.values(employees).find((employee: Employee) => employee.legacyUserId === user?.id);
    if (!me) return null;

    return {
      ...me,
      profileImage: user.profileImage,
    };
  }, [employees]);

  if (!me) return null;

  return (
    <Container maxWidth='lg'>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Typography variant='h5' gutterBottom>
                Préférences du compte
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Breadcrumbs>
                <Link href='/dashboard'>Dashboard</Link>
                <Link href={`/dashboard/user/${me.legacyUserId}`}>Profil</Link>
                <Typography color='inherit'>Préférences</Typography>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4}>
          <PhotoCard user={me} openToast={openToast} />
        </Grid>

        <Grid item xs={12} sm={8}>
          <InformationCard user={me} openToast={openToast} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Settings;
